import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import authService from '@/services/authService';
Vue.use(VueApollo);
const httpLink = createHttpLink({
    uri: process.env.VUE_APP_GRAPHQL_URL,
});
const authLink = setContext(async () => {
    if (authService.currentUser != null) {
        const token = await authService.currentUser.getIdToken();
        return {
            headers: {
                authorization: `Bearer ${token}`
            }
        };
    }
    else {
        return {};
    }
});
const link = authLink.concat(httpLink);
const cache = new InMemoryCache();
const apolloClient = new ApolloClient({
    link,
    cache,
});
const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
});
export default apolloProvider;
